var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"loading"},[_c('v-row',{attrs:{"align":"center"}},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-progress-circular',{attrs:{"width":3,"color":"secondary","indeterminate":""}})],1)],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }